export enum TransferTemplateStatuses {
  Active = 'Active',
  Archived = 'Archived',
}
